import type { Media, PDPVideo } from "@shared/graphql.types";

export const isVideoType = (data: Media): data is PDPVideo => {
  return Boolean((data as PDPVideo)?.imageUrl);
};
